class PredictiveSearch extends HTMLElement {
        constructor() {
            super();
            this.cachedResults = {};
            this.input = this.querySelector('input[type="search"]');
            // 通过全局 ID 查找外部的结果容器（关键修改点）
            this.resultsContainer = document.getElementById('search-results-container');
            this.predictiveSearchResults = this.resultsContainer.querySelector('.predictive-search__results');
            this.loadingState = this.resultsContainer.querySelector('.predictive-search__loading-state');
            this.overlay = this.querySelector('.predictive-search__overlay');
            this.isOpen = false;
            this.controller = new AbortController();
            this.working = false;
            this.hasPlaceholder = false;
            this.timeoutQuery;
            this.timeoutRunTop;

            this.setupEventListeners();
        }

        setupEventListeners() {
            const form = this.querySelector('form.search');
            form.addEventListener('submit', this.onFormSubmit.bind(this));

            this.input.addEventListener('input', (event) => {
                this.open();
                this.setLiveRegionLoadingState();
                if (this.timeoutQuery) {
                    clearTimeout(this.timeoutQuery);
                    this.working = false;
                }
                this.timeoutQuery = setTimeout(this.onChange.bind(this), 300); // 防抖延迟 300ms
            });

            this.input.addEventListener('focus', this.onFocus.bind(this));
            this.addEventListener('focusout', this.onFocusOut.bind(this));
            this.overlay.addEventListener('click', this.onClickOverlay.bind(this));
        }

        getQuery() {
            return this.input.value.trim();
        }

        onChange() {
            const searchTerm = this.getQuery();
            if (!searchTerm.length) {
                this.close(true);
                $(".exposure-search-delete").addClass('hidden')
                return;
            }
            $(".exposure-search-delete").removeClass('hidden')
            this.getSearchResults(searchTerm);
        }

        onFormSubmit(event) {
            if (!this.getQuery().length || this.predictiveSearchResults.querySelector('[aria-selected="true"] a')) {
                event.preventDefault();
            }
        }

        onFocus() {
            const searchTerm = this.getQuery();
            if (!searchTerm.length) return;
            if (this.hasAttribute('results')) {
                this.open();
            } else {
                this.getSearchResults(searchTerm);
            }
        }

        onFocusOut() {
            setTimeout(() => {
                if (!this.contains(document.activeElement) && !this.resultsContainer.contains(document.activeElement)) {
                    this.close();
                }
            }, 200);
        }

        onClickOverlay() {
            this.close();
        }

        // getSearchResults(searchTerm) {
        //     const queryKey = searchTerm.replace(" ", "-").toLowerCase();

        //     if (!Shopify.designMode && this.cachedResults[queryKey]) {
        //         this.renderSearchResults(this.cachedResults[queryKey]);
        //         return;
        //     }

        //     if (this.working) {
        //         this.controller.abort();
        //         this.controller = new AbortController();
        //     }
        //     const signal = this.controller.signal;
        //     this.working = true;

        //     // AJAX 请求
        //     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`, { signal })
        //         .then(response => response.text())
        //         .then(text => {
        //             const resultsMarkup = this.parseResults(text); 
        //             this.cachedResults[queryKey] = resultsMarkup;
        //             this.renderSearchResults(resultsMarkup);
        //             // 隐藏 re_po_art 类的元素
        //             const elementsToHide = document.querySelectorAll('.re_po_art');
        //             elementsToHide.forEach(element => {
        //                 element.style.display = 'none';
        //             });
        //         })
        //         .catch(error => {
        //             console.error('Search failed:', error);
        //             this.close();
        //         })
        //         .finally(() => {
        //             this.working = false;
        //         });
        // }

        getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      
        if (!Shopify.designMode && this.cachedResults[queryKey]) {
          this.renderSearchResults(this.cachedResults[queryKey]);
          // 添加缓存结果的高亮处理
          this.highlightKeywords(searchTerm, '.exposure-search-tag_all'); 
          return;
        }
      
        if (this.working) {
          this.controller.abort();
          this.controller = new AbortController();
        }
        
        const signal = this.controller.signal;
        this.working = true;
      
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`, { 
          signal 
        })
        .then(response => response.text())
        .then(text => {
          const resultsMarkup = this.parseResults(text);
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          
          // 隐藏报告元素
          // document.querySelectorAll('.re_po_art').forEach(el => {
          //   el.style.display = 'none';
          // });
        
          // 新增高亮处理（必须在DOM渲染后执行）
          this.highlightKeywords(searchTerm, '.exposure-search-tag_all');
        })
        .catch(error => {
          console.error('Search failed:', error);
          this.close();
        })
        .finally(() => {
          this.working = false;
        });
      }
      
      // 新增高亮方法
      highlightKeywords(keyword, containerSelector) {
        if (!keyword || keyword.trim() === '') return;
        // 转义正则特殊字符
        const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escapedKeyword})`, 'gi');
        document.querySelectorAll(containerSelector).forEach(container => {
          const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
          console.log(walker);
          while(walker.nextNode()) {
            const node = walker.currentNode;
            if (node.parentNode.nodeName === 'STRONG') continue;
            console.log(node);
            const newHtml = node.nodeValue.replace(regex, '<strong class="search-highlight_hstr text-[#0f1419] font-[Mona_Sans_Regular] font-[var(--font-body-weight-bold)]">$1</strong>');
            if (newHtml !== node.nodeValue) {
              const temp = document.createElement('div');
              temp.innerHTML = newHtml;
              node.replaceWith(...temp.childNodes);
            }
          }
        });
      }


        // 解析搜索结果
        parseResults(text) {
            return new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        }

        setLiveRegionLoadingState() {
            this.loadingState.textContent = '';
            this.hasPlaceholder = true;
        }

        renderSearchResults(resultsMarkup) {
            this.predictiveSearchResults.innerHTML = resultsMarkup.innerHTML;
            $(this.resultsContainer).removeClass('hidden');
            this.loadingState.textContent = ''; // 清除加载状态
        }

        open() {
            if (!this.isOpen) {
                this.overlay.style.display = 'block';
                this.input.setAttribute('aria-expanded', true);
                this.isOpen = true;
            }
        }

        close(clearSearchTerm = false) {
            if (clearSearchTerm) {
                this.input.value = '';
                $(this.resultsContainer).addClass('hidden');
            }
            this.overlay.style.display = 'none';
            this.input.setAttribute('aria-expanded', false);
            this.isOpen = false;
        }
    }

    customElements.define('predictive-search', PredictiveSearch);